// extracted by mini-css-extract-plugin
module.exports = {"Button":"CommentDropDownMenu_Button__K_6D2","Icon":"CommentDropDownMenu_Icon__Z6s5E","Checkbox":"CommentDropDownMenu_Checkbox__28GIs"};